import { Button } from "@fxc/ui-kit";
import { keycloak } from "@/entities/keycloak";

export function SessionRefreshNotification() {
  return (
    <>
      <p>Failed to refresh the token, or the session has expired.</p>
      Please, click
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <Button onClick={() => keycloak.login()}>here</Button> to login and try
      again after that.
    </>
  );
}
